import {md5} from "hash";

// const log = global.log.getLogger("f_mtac.utils.Hash");

export let hash = function({data, secret}) {
    return md5.hash(data + secret);
};

export let GlobalHash = function(secret) {
    let global_hash = new md5.state();
    let updated = new Date(0);
    this.reset = function() {
        global_hash.end();
        // initializing to empty hash( hash("" + secret) + secret)
        global_hash.append(md5.hash(secret) + secret);
    };
    this.reset();

    Object.defineProperty(this, "state", {
        get: () => {
            let {buff, hash, length} = global_hash.getState();
            return {buffer: buff, state: hash, count: length};
        },
        set: ({buffer, count, state}) => {
            global_hash.setState({buff: buffer, hash: state, length: count});
            updated.setTime(Date.now());
        }
    });

    Object.defineProperty(this, "updated", {
        get: () => updated,
        set: () => {}
    });

    this.append_hash = function(hash) {
        global_hash.append(hash);
        global_hash.append(secret);
        updated.setTime(Date.now());
    };

    this.compute = function() {
        let current_global_hash = $.extend(true, {}, global_hash);
        return current_global_hash.end();
    };
};


